import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from 'app/modules/auth/_services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mobile-sidebar',
  templateUrl: './mobile-sidebar.component.html',
  styleUrls: ['./mobile-sidebar.component.scss']
})
export class MobileSidebarComponent implements OnInit {

  @Input() userName!: string;
  @Output() close = new EventEmitter<void>();

  userDetails: any;
  vendorId!: string;

  menuItems = [
    { path: "/app/profile-page", title: "Home", icon: "/assets/img/Home.svg" },
    { path: "/app/dashboard", title: "Engagements", icon: "/assets/img/Graph.svg" },
    { path: "/app/packages", title: "My Packages", icon: "/assets/img/Gift.svg" },
    // { path: "/app/portfolio", title: "Portfolio", icon: "/assets/img/dashboard-icon.svg" },
    { path: "/app/message", title: "Messages", icon: "/assets/img/message-icon.svg" },
    { path: "/app/profile/profile-information", title: "Settings", icon: "/assets/img/settings-icon.svg" },
  ];

  user = {
    image: '/assets/img/user-icon.png'
  };

  icons = {
    close: '/assets/img/x.svg',
    help: '/assets/images/help.svg',
    bell: '/assets/img/notification-icon.svg'
  };

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.userDetails = this.authService.getUser();

    if (!this.userDetails) {
      console.warn('User not found');
      return;
    }

    // ✅ Correctly extract vendor ID
    if (this.userDetails?.vendorDetails?._id) {
      this.vendorId = this.userDetails.vendorDetails._id;
    } else {
      this.vendorId = this.userDetails._id;
    }
  }

  logout(): void {
    this.authService.logout();
  }

  onClose(): void {
    this.close.emit();
  }

  // goTo(item: any): void {
  //   if (item.path === '/app/profile-page') {
  //     // ✅ Return ID in URL
  //     this.router.navigate(['/app/profile-page', this.vendorId]);
  //   } else {
  //     this.router.navigate([item.path]);
  //   }

  //   this.onClose(); // close sidebar after navigation
  // }
}
